'use client';

import { createContext } from 'react';

import type { TimeFormat } from '@repo/ui/constants/timezone';

export interface TimezoneContextProps {
  timezone: string;
  updateTimezone: (timezone: string) => void;
  timeFormat: TimeFormat;
  updateTimeFormat: (format: TimeFormat) => void;
}

export const TimezoneContext = createContext<TimezoneContextProps | undefined>(undefined);
